import { render, staticRenderFns } from "./CustomizeMetalG.vue?vue&type=template&id=d4c93d04&scoped=true"
import script from "./CustomizeMetalG.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalG.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalG.vue?vue&type=style&index=0&id=d4c93d04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c93d04",
  null
  
)

export default component.exports